import { Container, Typography, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import SubmitButton from "../components/common/SubmitButton";
import KycAnimation from "../components/Lottie/KycAnimation";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import PopUp from "../components/common/PopUp";
import MsgConfirmation from "../components/common/MsgConfirmation";
import { apis } from "../services/apiService";
import IngenicoEnach from "../utils/IngenicoEnach";
import LoadingDots from "../components/Lottie/LoadingDots";
import Backdrop from "../components/common/Backdrop";
import { removeScriptFile } from "../utils/utils";
import styles from "../Style/Modules/pendingEnach.module.css";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function PendingENACH() {
  const { openEnachScreen } = IngenicoEnach();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  const [enachReqData, setEnachReqData] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [checkNachInitiateStatus, setCheckNachInitiateStatus] = useState("");
  let location = useLocation();
  const navigate = useNavigate();

  const getEnachUMRStatus = async (appId = location?.state?.AppId) => {
    try {
      let resp = await apis.getApi(
        `${configData.API_URL}Enach/VerifyEnachStatus?applicationId=${appId}`
      );
      if (resp?.status === 200) {
        let result = await resp?.json();
        if (result?.data?.result === "NotAvailable") {
          setTimeout(() => {
            getEnachUMRStatus(appId);
          }, 30000);

          setBtnDisabled(true);
          setCheckNachInitiateStatus(
            "ENACH registration in progress, please wait."
          );
        } else if (result?.data?.result === "Available") {
          navigate("/complete-kyc", {
            state: { AppId: location?.state?.AppId },
          });
        } else if (!result?.data?.result) {
          // getEnachUMRStatus(appId);
        }
      }
    } catch (error) {
      setLoading(false);
      // setDisabled(true);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // openEnachScreen(enachReqData, getEnachUMRStatus(location?.state?.AppId));
    openEnachScreen(enachReqData);
  };
  const getEnachDetail = async () => {
    setLoading(true);
    try {
      const reqData = {
        aid: location?.state?.AppId,
        acc: "",
        ifsc: "",
        atype: "",
      };
      // alert("1");
      let resp = await apis.postApi(
        configData.API_URL + "Enach/GetEnachDetails",
        reqData
      );
      let result = await resp.json();
      if (resp.status === 200) {
        setEnachReqData(result?.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // setDisabled(true);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
      // setEnachReqData(errorResult?.data);
    }
  };

  useEffect(() => {
    // location?.state?.AppId && getEnachDetail();
    getEnachDetail();
    getEnachUMRStatus();
  }, []);

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={10} />
        <Box className={styles.pendingEnachBox}>
          <KycAnimation />
          <Box className={styles.pendingEnachBox1}>
            <Typography
              variant="h2"
              sx={{ mt: 1, mb: 2, fontWeight: "bold", color: "#0D1C6E" }}
            >
              {t("ENACH Inprogress")}
            </Typography>
            <Typography variant="p" color="info" sx={{ textAlign: "center" }}>
              {t(
                "Your ENACH is in progress, kindly press Continue to proceed."
              )}
            </Typography>
          </Box>
        </Box>
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
        {checkNachInitiateStatus && (
          <Typography
            variant="h6"
            color="red"
            sx={{ textAlign: "center", mt: "10px" }}
          >
            {checkNachInitiateStatus}
          </Typography>
        )}
        {finalErr && (
          <Backdrop ax="center">
            <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
          </Backdrop>
        )}
      </Container>
      <form onSubmit={handleSubmit}>
        <SubmitButton hasNote="No" disabled={btnDisabled} />
      </form>
    </>
  );
}
